import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { map, Observable } from 'rxjs';
import { EmployeeService } from '../services/employee-service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-applyleave',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatIconModule
  ],
  providers: [DatePipe],
  templateUrl: './applyleave.component.html',
  styleUrls: ['./applyleave.component.css']   // ✅ should be styleUrls (array), not styleUrl
})

export class ApplyleaveComponent {
  leaveForm: FormGroup;
  isLoading = false;
  medicalLeave=false;
  leaveCategories$!: Observable<any[]>;
  LeaveType$!: Observable<any[]>;
  holidayStatus$!: Observable<any[]>;
  empNo: string = '';
  availableLeave:number =-1;
  medicalCertificateFileName: string | null = null;
  medicalCertificate: string | null = null;
  constructor(private fb: FormBuilder, private employeeService: EmployeeService, private router: Router, private snackBar: MatSnackBar, private datePipe: DatePipe) {
    this.leaveForm = this.fb.group({
      leave_category_id: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      holiday_status_id: 1,
      reason: ['', Validators.required],

    });
    let code = sessionStorage.getItem("user_code");
    if (code && code.length > 0)
      this.empNo = code;
  }

  ngOnInit() {
    this.getLeaveCategories();
  }

  getLeaveCategories() {
    this.leaveCategories$ = this.employeeService.getLeaveCategories().pipe(
      map((res: any) => res.result.data)
    );
  }

  getLeaveTypes(categoryId: number) {
    this.LeaveType$ = this.employeeService.getLeaveTypes().pipe(
      map((res: any) => res.result.data)
    );
  }

  onLeaveTypeChange(event: any) {
    const selectedName = event.source.selected.viewValue?.toLowerCase();
    if (selectedName && selectedName.toLowerCase().includes('contract vacation')) {
      this.medicalLeave=false;
      this.employeeService.getAvailableContractLeave(this.empNo, this.leaveForm.value.leave_category_id).subscribe(res => {
        this.availableLeave=res.result.available_leaves;
      });
    }
    else  if (selectedName && selectedName.toLowerCase().includes('medical')){
        this.medicalLeave=true;
    }
    else{
      this.availableLeave=-1;
        this.medicalLeave=false;
    }
  }

  onFileChange(event: any) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
     this.medicalCertificateFileName = file.name;  
    this.uploadFileAsBinary(file);
  }

   uploadFileAsBinary(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.split(',')[1];    
        this.medicalCertificate = base64; 
    };
    reader.readAsDataURL(file);
  }

 
  submitLeave() {    
    if (this.leaveForm.invalid) {
      this.leaveForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    
    const payload = {
      jsonrpc: '2.0',
      method: 'call',
      params: {
        start_date: this.datePipe.transform(this.leaveForm.value.start_date, 'yyyy-MM-dd'),
        end_date: this.datePipe.transform(this.leaveForm.value.end_date, 'yyyy-MM-dd'),
        holiday_status_id: 1,
        leave_category_id: this.leaveForm.value.leave_category_id,
        name: this.leaveForm.value.reason,
        medical_attachment :this.medicalCertificate,
        medical_attachment_name :this.medicalCertificateFileName         
      }
    };

    this.employeeService.applyLeave(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res && res.result && res.result.status == 200) {
          // this.router.navigate(['/registration-success', res.result.approval_id,'vendor']);
          this.snackBar.open('Leave applied successfully', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
        else {
          this.snackBar.open('Leave application failed, contact HR department', 'Close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.snackBar.open('Leave application failed, contact HR department', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      }
    });
  }
}
